export default __webpack_public_path__ + "static/media/openmenu.a2a4c250.svg";